export * from './FoldingHeadingSpecs';
